import fetchCourseWaitlist, { removeEnrolledLearnersFromWaitlist } from 'redux/actions/enrollment-waitlist';
import { createReducer } from '@reduxjs/toolkit';
import { initialRootState } from '.';

export default createReducer(initialRootState, builder => {
  builder
    .addCase(fetchCourseWaitlist.fulfilled, (state, action) => {
      // Sort waitlist entries by joinedAt in ascending order (oldest first, newest last)
      const sortedWaitlist = [...action.payload].sort((a, b) => {
        const dateA = new Date(a.joinedAt).getTime();
        const dateB = new Date(b.joinedAt).getTime();
        return dateA - dateB;
      });
      state.app.currentCourseWaitlist = sortedWaitlist;
    })
    .addCase(removeEnrolledLearnersFromWaitlist, (state, action) => {
      if (state.app.currentCourseWaitlist) {
        state.app.currentCourseWaitlist = state.app.currentCourseWaitlist.filter(
          entry => !action.payload.includes(entry.userId),
        );
      }
    });
});
